export default __webpack_public_path__ + "static/media/slide3.a0f6a604.jpg";